const EMAIL_QUEUE_REFRESHED_EVENT = 'admin-email-queue-refreshed';

export function notifyEmailQueueRefreshed(): void {
  window.dispatchEvent(new Event(EMAIL_QUEUE_REFRESHED_EVENT));
}

/** Refresh the authoritative total, never a filtered or paginated table count. */
export function subscribeEmailQueueRefresh(reload: () => Promise<void>): () => void {
  let disposed = false;
  let running = false;
  let pending = false;
  const refresh = async () => {
    if (disposed || document.hidden) return;
    if (running) { pending = true; return; }
    running = true;
    try {
      do {
        pending = false;
        await reload();
      } while (pending && !disposed && !document.hidden);
    } finally {
      running = false;
    }
  };
  // The query reports failures; keep event handlers free of unhandled rejections.
  const onRefresh = () => { void refresh().catch(() => {}); };
  window.addEventListener(EMAIL_QUEUE_REFRESHED_EVENT, onRefresh);
  window.addEventListener('focus', onRefresh);
  document.addEventListener('visibilitychange', onRefresh);
  const timer = window.setInterval(onRefresh, 60_000);
  return () => {
    disposed = true;
    window.clearInterval(timer);
    window.removeEventListener(EMAIL_QUEUE_REFRESHED_EVENT, onRefresh);
    window.removeEventListener('focus', onRefresh);
    document.removeEventListener('visibilitychange', onRefresh);
  };
}
